import memberBookingTemplate from './member_booking.html';

function MemberBookingDirective() {
    'ngInject';

    function link(scope, element, attrs, controllers) {
        const BOOKING_STATUS = {
            ENQUIRY: 'Enquiry',
            BOOKING: 'Booking',
            RESERVATION: 'Reservation'
        };

        scope.actions = [];

        const member_booking_controller = controllers[0] ? controllers[0] : controllers[1];
        const time_now = moment();

        if (scope.booking.on_waitlist && !scope.booking.datetime.isBefore(time_now, 'day')) {
            scope.actions.push({
                action: member_booking_controller.book,
                label: 'Book',
                translation_key: 'MEMBER_BOOKING_WAITLIST_ACCEPT',
                disabled: !scope.booking.settings.sent_waitlist
            });
        }

        // The booking is an Enquiry, so the user can not pay
        if (scope.booking.status === BOOKING_STATUS.ENQUIRY) {
            scope.actions.push({disabled: true, label: 'Confirmation pending'});
        } else if ((scope.booking.paid < scope.booking.price) && scope.booking.datetime.isAfter(time_now)) {
            scope.actions.push({action: member_booking_controller.pay, label: 'Pay'});
        }

        scope.actions.push({
            action: member_booking_controller.edit,
            label: 'Details',
            translation_key: 'MEMBER_BOOKING_EDIT'
        });

        if (!scope.booking.datetime.isBefore(time_now, 'day')) {
            return scope.actions.push({
                action: member_booking_controller.cancel,
                label: 'Cancel',
                translation_key: 'MEMBER_BOOKING_CANCEL'
            });
        }
    }

    return {
        templateUrl: memberBookingTemplate.id,
        scope: {
            booking: '=bbMemberBooking'
        },
        require: ['^?bbMemberUpcomingBookings', '^?bbMemberPastBookings'],
        link
    };
}

angular
    .module('BBMember')
    .directive('bbMemberBooking', MemberBookingDirective);


// WEBPACK FOOTER //
// node_modules/bookingbug-angular/src/member/member-booking/member_booking.directive.js